{
   "app" : {
      "language_names" : {
         "english" : "Englisch",
         "german" : "Deutsch"
      }
   },
   "credential" : {
      "credential_unavailable" : "Dieser Ausweis ist nicht verfügbar, entweder weil er bereits verwendet wurde oder weil er entfernt wurde.",
      "device_unsupported" : "Dieses Gerät wird nicht unterstützt",
      "error_not_found" : "Ausweis nicht gefunden",
      "error_not_found_description" : "Ausweis nicht gefunden. Bitte stellen Sie sicher, dass Sie den richtigen Link verwenden.",
      "error_provider" : "Fehler beim Bereitstellen des Credentials",
      "error_provider_description" : "Der Credentialanbieter hat ein Problem gemeldet. Bitte versuchen Sie es später erneut.",
      "error_unknown" : "Unbekannter Fehler aufgetreten. Wenn dieser Fehler weiterhin besteht, wenden Sie sich bitte an den Support. Fehlercode: {code}",
      "provider_redirect" : "Weiterleitung zum Anbieter...",
      "provider_unsupported" : "Dieser Anbieter wird nicht unterstützt. Bitte aktualisieren Sie diese Seite.",
      "sso_not_supported" : "Dieser Ausweis wird derzeit nicht unterstützt.",
      "title_android" : "Fügen Sie Ihrem Android-Gerät Ihren {name} Ausweis hinzu",
      "title_ipad" : "Das Hinzufügen Ihres {name} Ausweises zu Ihrem iPad wird nicht unterstützt",
      "title_iphone" : "Fügen Sie Ihren {name} Ausweis zu Ihrem iPhone oder Ihrer Uhr hinzu",
      "title_mfa" : "Einmalpasswort erforderlich",
      "title_other" : "Um Ihren {name} Ausweis hinzuzufügen, scannen Sie bitte den unten stehenden QR-Code mit Ihrem Mobilgerät.",
      "title_unavailable" : "Dieses Credential ist nicht verfügbar",
      "wallet_redirect" : "Weiterleitung zum Wallet...",
      "warning" : "Achten Sie beim Benutzen Ihres Ausweises auf Ihre Umgebung und schützen Sie ihn vor Blicken, damit niemand Ihre Zugangsdaten sieht. Indem Sie auf die Sicherheit Ihres Ausweises achten, schützen Sie sich und das Unternehmen."
   },
   "footer" : {
      "privacy_policy" : "Datenschutzrichtlinien"
   },
   "mfa" : {
      "btn_confirm" : "Bestätigen",
      "btn_request" : "Anfragen",
      "btn_request_again" : "Erneut anfragen",
      "btn_retry" : "Wiederholen",
      "request_error" : "Bei der Verarbeitung des Einmalpassworts ist ein Fehler aufgetreten.",
      "request_failed" : "Falsches Einmalpasswort.",
      "requested_both" : "Eine E-Mail und SMS mit dem Einmalpasswort wurde an {email} und {phone} gesendet",
      "requested_email" : "Eine E-Mail mit dem Einmalpasswort wurde an {email} gesendet.",
      "requested_phone" : "Eine SMS mit dem Einmalpasswort wurde an {phone} gesendet",
      "requested_unknown" : "Das Einmalpasswort wurde angefordert",
      "token_placeholder" : "000000"
   },
   "not_found" : {
      "message" : "Der Link ist ungültig. Bitte stellen Sie sicher, dass Sie den richtigen Link verwenden."
   },
   "platform" : {
      "android" : {
         "start" : "Zu Google Wallet hinzufügen"
      },
      "desktop" : {
         "issue_with_credential_key" : "Sie können diesen Ausweis nicht mit Ihrem Desktop-Computer hinzufügen. Versuchen Sie, den Link auf Ihrem Mobilgerät zu öffnen."
      },
      "ios" : {
         "start" : "Zu Apple Wallet hinzufügen"
      }
   }
}
